'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { updateSearchParams, getSearchParams, removeSearchParam } from "@utils";



const RoomFilter = ({ title, roomTypes, lang, dictionary }) => {
    const router = useRouter();
    let [room, setRoom] = useState(roomTypes[lang][0])
    let [addChecked, setAddChecked] = useState(roomTypes[lang][0].value)


    const handleUpdateParams = (e) => {
        let newPathName
        if (e.value == 0) {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, e.value);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const roomValue = getSearchParams('room')
        setAddChecked(roomValue)
        const newValue = roomTypes[lang].find(obj => obj.value === addChecked);

        if (newValue != undefined) {
            setRoom(newValue)
        } else {
            setRoom(roomTypes[lang][0])
        }

    }, [handleUpdateParams])

    return (
        <div className="w-full z-1">
            <span className='text-maincolor text-xl pb-2'>{dictionary.numberOfBedrooms}:</span>
            <div className="w-full z-1">
                <RadioGroup value={room} onChange={(value) => {
                    setRoom(value)
                    handleUpdateParams(value)
                }}
                    className='z-1 w-full flex flex-row mt-2 rounded-lg shadow-md border-[1px] border-forth overflow-hidden'
                >
                    {roomTypes[lang].map((roomType) => (
                        <RadioGroup.Option
                            key={roomType.value}
                            value={roomType}
                            checked={roomType === room}
                            className={({ active, checked }) =>
                                `${active
                                    ? ''
                                    : ''
                                }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                                }
                                w-full z-1 flex cursor-pointer px-2 py-2 shadow-md focus:outline-none`
                            }
                        >
                            {({ active, checked }) => (
                                <>
                                    <div className="flex w-full items-center justify-center">
                                        <div className="flex items-center">
                                            <div className="text-sm text-center">
                                                <RadioGroup.Label
                                                    as="p"
                                                    className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                        }`}
                                                >
                                                    {roomType.title}
                                                </RadioGroup.Label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </RadioGroup.Option>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )
}

export default RoomFilter